export var reduxDev = function reduxDev() {
  // eslint-disable-next-line no-underscore-dangle
  var devtoolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;
  return devtoolsExtension ? devtoolsExtension() : function (f) {
    return f;
  };
};
export var styleLoader = function styleLoader() {
  if (module.hot) {
    module.hot.addStatusHandler(function (status) {
      if (status === 'idle') {
        document.querySelectorAll('link[href][rel=stylesheet]').forEach(function (link) {
          if (link.href.indexOf('localhost') > -1) {
            link.href = link.href.replace(/(\?r=\d+)?$/, "?r=" + Date.now());
          }
        });
      }
    });
  }
};